import script from "./CustomPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomPanel.vue?vue&type=script&setup=true&lang=ts"

import "./CustomPanel.vue?vue&type=style&index=0&id=4aa7876d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa7876d"]])

export default __exports__